import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { EventTrackingService } from 'src/app/application/usesCases/event-tracking.service';
import { AuthInfrastructureModule } from 'src/app/auth/infrastructure/auth-infrastructure.module';
import { FastDataAdapterService } from 'src/app/infraestructure/adapters/fast-data.service';
import { AuthRoutingModule } from './auth-routing.module';
import { LoginFormComponent } from './components/login-form/login-form.component';
import { LoginComponent } from './pages/login/login.component';
import { NewPasswordComponent } from './pages/new-password/new-password.component';
import { PasswordRecoveryComponent } from './pages/password-recovery/password-recovery.component';

@NgModule({
  declarations: [
    LoginComponent,
    LoginFormComponent,
    NewPasswordComponent,
    PasswordRecoveryComponent,
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    ReactiveFormsModule,
    AuthInfrastructureModule,
  ],
  providers: [
    FastDataAdapterService,
    EventTrackingService,
    { provide: 'IEventTrackingPort', useClass: FastDataAdapterService },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AuthModule {}
